import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";

import FlatrateQuery from "@/graphql/FlatrateQuery";
import { IFlatrate } from "@/selfdisclosure.interfaces";

@Module({ namespaced: true, name: "FlatrateStore" })
export default class SelfDisclosure extends VuexModule {
    flatrate: IFlatrate = {
        available: false,
        error: "",
        info: {
            identDone: false,
            paySlipUploaded: false,
            bankDataProvided: false,
            bank: "",
            bankCity: "",
            bic: "",
            iban: "",
            firstName: "",
            lastName: "",
            gender: "",
            identId: null,
            monthlyNetIncome1: null,
            monthlyNetIncome2: null,
            monthlyNetIncome3: null,
            monthlyIncomeRenting: null,
            monthlyIncomeOther: null
        }
    };

    @Action({ rawError: true })
    fetchData({apollo, variables}: any) {

        return apollo.query({
            query: FlatrateQuery,
            variables
        }).then((res: any) => {
            this.context.commit("setFlatrateData", res.data.flatrateLandingpage);
            return res.data.flatrateLandingpage;
        });
    }

    @Mutation
    setFlatrateData(payload: any) {
        this.flatrate = payload;
    }

    @Mutation
    setPayslipDone() {
        this.flatrate.info.paySlipUploaded = true;
    }

    @Mutation
    setBankDataDone() {
        this.flatrate.info.bankDataProvided = true;
    }
}
